import { active } from "@api/stores/active/api";
import { activeSubscriptionStats } from "@api/stores/activeSubscriptionStats/api";
import { costs } from "@api/stores/costs/api";
import { customerReports } from "@api/stores/customerReports/api";
import { customers } from "@api/stores/customers/api";
import { deactive } from "@api/stores/deactive/api";
import { employeeActivities } from "@api/stores/employeeActivities/api";
import { employeeCosts } from "@api/stores/employeeCosts/api";
import { employeeStats } from "@api/stores/employeeStats/api";
import { financial } from "@api/stores/financial/api";
import { measurementUnits } from "@api/stores/measurementUnits/api";
import { notifications } from "@api/stores/notifications/api";
import { productBatches } from "@api/stores/productBatches/api";
import { productCategories } from "@api/stores/productCategories/api";
import { productPrices } from "@api/stores/productPrices/api";
import { productReports } from "@api/stores/productReports/api";
import { products } from "@api/stores/products/api";
import { purchaseInvoiceItemReport } from "@api/stores/purchaseInvoiceItemReport/api";
import { purchaseInvoiceReport } from "@api/stores/purchaseInvoiceReport/api";
import { purchaseInvoiceReturns } from "@api/stores/purchaseInvoiceReturns/api";
import { purchaseInvoices } from "@api/stores/purchaseInvoices/api";
import { readStatus } from "@api/stores/readStatus/api";
import { salesInvoiceItemReport } from "@api/stores/salesInvoiceItemReport/api";
import { salesInvoiceReport } from "@api/stores/salesInvoiceReport/api";
import { salesInvoiceReturns } from "@api/stores/salesInvoiceReturns/api";
import { salesInvoices } from "@api/stores/salesInvoices/api";
import { setPassword } from "@api/stores/setStoreUserPassword/api";
import { storeStats } from "@api/stores/storeStats/api";
import { suppliers } from "@api/stores/suppliers/api";
import { users } from "@api/stores/users/api";
import { warehouses } from "@api/stores/warehouses/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";
import { createPatchApi } from "@api/util/createPatchApi";
import { createPostApi } from "@api/util/createPostApi";
import { warehouseCirculations } from "src/api/stores/warehouseCirculation/api";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam, IPathByIdParam } from "./path";
import type { IStoresDto, IStoresGetAllParams, IStoresResponse } from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IStoresResponse>>,
  IPathBaseParam,
  IPaginationParams & IStoresGetAllParams
>("stores");
const postApis = createPostApi<
  IApiResponse<IStoresResponse>,
  IPathBaseParam,
  IStoresDto
>("stores");
const getApis = createGetApi<
  IApiResponse<IStoresResponse>,
  IPathByIdParam,
  object
>("stores");
const patchApis = createPatchApi<
  IApiResponse<IStoresResponse>,
  IPathByIdParam,
  IStoresDto
>("stores");

export const stores = {
  ...getAllApis,
  ...getApis,
  ...postApis,
  ...patchApis,
  active,
  deactive,
  setPassword,
  warehouses,
  productCategories,
  measurementUnits,
  users,
  customers,
  suppliers,
  costs,
  employeeCosts,
  products,
  activeSubscriptionStats,
  productPrices,
  salesInvoices,
  productBatches,
  purchaseInvoices,
  salesInvoiceReturns,
  purchaseInvoiceReturns,
  salesInvoiceReport,
  salesInvoiceItemReport,
  purchaseInvoiceReport,
  purchaseInvoiceItemReport,
  warehouseCirculations,
  financial,
  employeeActivities,
  productReports,
  customerReports,
  storeStats,
  employeeStats,
  notifications,
  readStatus,
};
